@import "styles/variables";

.date-picker-container {
  flex-grow: 0;
  margin-right: 15px;
}

.row {
  width: 100%;
  position: relative;
}

.date-wrapper {
  display: inline-block;
  margin-right: 15px;
  width: 92px;
}

.time-wrapper {
  display: inline-block;
}

.time-separator {
	display: inline-block;
	vertical-align: bottom;
	padding: 11px 5px;
}

:global {

	.date-picker {
	  border-radius: var(--input-border-radius);
	  background-color: var(--color-white);
	  border: 1px solid;
	  border-color: var(--color-grey);
	  box-sizing: border-box;
	  width: 100%;
	  padding: 7px;
	  font-family: var(--font-stack-default);
	  font-size: var(--font-size-medium);
	  font-weight: normal;
	  color: var(--color-black-transparent);
	  outline: none;
	  margin: 6px 0 0;
	  height: 36px; 
	}

	.date-picker.has-error {
		border-color: var(--color-border-error);
	}

}

:global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, :global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, :global .react-datepicker__year-read-view--down-arrow, :global .react-datepicker__month-read-view--down-arrow {
  margin-left: -8px;
  position: absolute;
}

:global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, :global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, :global .react-datepicker__year-read-view--down-arrow, :global .react-datepicker__month-read-view--down-arrow, :global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, :global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, :global .react-datepicker__year-read-view--down-arrow::before, :global .react-datepicker__month-read-view--down-arrow::before {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
}

:global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, :global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, :global .react-datepicker__year-read-view--down-arrow::before, :global .react-datepicker__month-read-view--down-arrow::before {
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
  border-bottom-color: var(--color-grey);	
}

:global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}

:global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, :global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: var(--color-white);
}

:global .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: var(--color-grey);
}

:global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, :global .react-datepicker__year-read-view--down-arrow, :global .react-datepicker__month-read-view--down-arrow {
  bottom: 0;
  margin-bottom: -8px;
}

:global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, :global .react-datepicker__year-read-view--down-arrow, :global .react-datepicker__month-read-view--down-arrow, :global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, :global .react-datepicker__year-read-view--down-arrow::before, :global .react-datepicker__month-read-view--down-arrow::before {
  border-bottom: none;
  border-top-color: #fff;
}

:global .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, :global .react-datepicker__year-read-view--down-arrow::before, :global .react-datepicker__month-read-view--down-arrow::before {
  bottom: -1px;
  border-top-color: var(--color-grey);
}

:global .react-datepicker-wrapper {
  display: inline-block;
}

:global .react-datepicker {
  font-family: var(--font-stack-default);
  font-size: 0.8rem;
  background-color: #f3f3f3;
  color: #000;
  border: 1px solid var(--color-grey);
  border-radius: 0.3rem;
  display: inline-block;
  position: relative;
	box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15);
}

:global .react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

:global .react-datepicker-popper {
  z-index: 1;
}

:global .react-datepicker-popper[data-placement^="bottom"] {
  margin-top: 0;
}

:global .react-datepicker-popper[data-placement^="top"] {
  margin-bottom: 0;
}

:global .react-datepicker-popper[data-placement^="right"] {
  margin-left: 8px;
}

:global .react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}

:global .react-datepicker-popper[data-placement^="left"] {
  margin-right: 8px;
}

:global .react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

:global .react-datepicker__header {
  text-align: center;
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-grey);
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  padding-top: 8px;
  position: relative;
}

:global .react-datepicker__header--time {
  padding-bottom: 8px;
}

:global .react-datepicker__year-dropdown-container--select,
:global .react-datepicker__month-dropdown-container--select,
:global .react-datepicker__year-dropdown-container--scroll,
:global .react-datepicker__month-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

:global .react-datepicker__current-month, :global .react-datepicker-time__header {
  margin-top: 0;
  color: #000;
  font-family: var(--font-stack-bold);
  font-size: 14px;
}

:global .react-datepicker__navigation {
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 30px;
  width: 30px;  
  z-index: 1;
}

:global .react-datepicker__navigation:after {
	position: absolute;
	display: block;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
  text-align: center;
  line-height: 33px;	
	font-family: var(--font-ionicons);
}

:global .react-datepicker__navigation--previous {
  left: 0;
  padding-left: 10px;	
}

:global .react-datepicker__navigation--previous:after {	
	content: '\f124';
}

:global .react-datepicker__navigation--previous:hover {
  opacity: 0.5;
}

:global .react-datepicker__navigation--next {
  right: 0;
	padding-right: 10px;  
}

:global .react-datepicker__navigation--next:after {	
	content: '\f125';	
}

:global .react-datepicker__navigation--next--with-time:not(:global .react-datepicker__navigation--next--with-today-button) {
  right: 80px;
}

:global .react-datepicker__navigation--next:hover {
  opacity: 0.5;
}

:global .react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

:global .react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ccc;
}

:global .react-datepicker__navigation--years-previous:hover {
  border-top-color: #b3b3b3;
}

:global .react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ccc;
}

:global .react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: #b3b3b3;
}

:global .react-datepicker__month-container {
  float: left;
}

:global .react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}

:global .react-datepicker__time-container {
  float: right;
  border-left: 1px solid var(--color-grey);
}

:global .react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid var(--color-grey);
  border-radius: .3rem;
  position: absolute;
  right: -72px;
  top: 0;
}

:global .react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 70px;
  overflow-x: hidden;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + (1.7rem / 2));
  overflow-y: scroll;
  padding-right: 30px;
  width: 100%;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  padding: 5px 10px;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: var(--color-yellow);
  font-weight: bold;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: var(--color-yellow);
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #c2c2c2;
}

:global .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

:global .react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

:global .react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}

:global .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 50%;
  background-color: #f0f0f0;
}

:global .react-datepicker__day-names, :global .react-datepicker__week {
  white-space: nowrap;
}

:global .react-datepicker__day-name,
:global .react-datepicker__day, :global .react-datepicker__time-name {
  color: #000;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

:global .react-datepicker__day {
  cursor: pointer;
}

:global .react-datepicker__day:hover {
	border-radius: 50%;
  transform: scale(1.2);
	background-color: #fff;  
}

:global .react-datepicker__day--today {
  font-weight: bold;
}

:global .react-datepicker__day--highlighted {
  border-radius: 50%;
  background-color: #3dcc4a;
  color: #fff;
}

/*:global .react-datepicker__day--highlighted:hover {
  background-color: #32be3f;  
}*/

:global .react-datepicker__day--highlighted-custom-1 {
  color: magenta;
}

:global .react-datepicker__day--highlighted-custom-2 {
  color: green;
}

:global .react-datepicker__day--selected, :global .react-datepicker__day--in-selecting-range, :global .react-datepicker__day--in-range {
  border-radius: 50%;
  background-color: var(--color-yellow);
}

:global .react-datepicker__day--selected:hover, :global .react-datepicker__day--in-selecting-range:hover, :global .react-datepicker__day--in-range:hover {
  background-color: var(--color-yellow);
}

:global .react-datepicker__day--keyboard-selected {
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.20), inset 1px 0 0 var(--color-yellow), inset -1px 0 0 var(--color-yellow), inset 0 1px 0 var(--color-yellow), inset 0 -1px 0 var(--color-yellow);
}

:global .react-datepicker__day--keyboard-selected:hover {
  background-color: #fff;
}

:global .react-datepicker__day--in-selecting-range:not(:global .react-datepicker__day--in-range) {
  background-color: rgba(33, 107, 165, 0.5);
}

.react-datepicker__month--selecting-range :global .react-datepicker__day--in-range:not(:global .react-datepicker__day--in-selecting-range) {
  background-color: #f0f0f0;
  color: #000;
}

:global .react-datepicker__day--disabled {
  cursor: default;
  color: #c2c2c2;
}

:global .react-datepicker__day--disabled:hover {
  background-color: transparent;
  transform: scale(1);
}

:global .react-datepicker__input-container {
  position: relative;
  display: inline-block;
}

:global .react-datepicker__year-read-view,
:global .react-datepicker__month-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
}

:global .react-datepicker__year-read-view:hover,
:global .react-datepicker__month-read-view:hover {
  cursor: pointer;
}

:global .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
:global .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
:global .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
:global .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}

:global .react-datepicker__year-read-view--down-arrow,
:global .react-datepicker__month-read-view--down-arrow {
  border-top-color: #ccc;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.45rem;
}

:global .react-datepicker__year-dropdown,
:global .react-datepicker__month-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid var(--color-grey);
}

:global .react-datepicker__year-dropdown:hover,
:global .react-datepicker__month-dropdown:hover {
  cursor: pointer;
}

:global .react-datepicker__year-dropdown--scrollable,
:global .react-datepicker__month-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

:global .react-datepicker__year-option,
:global .react-datepicker__month-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

:global .react-datepicker__year-option:first-of-type,
:global .react-datepicker__month-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

:global .react-datepicker__year-option:last-of-type,
:global .react-datepicker__month-option:last-of-type {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

:global .react-datepicker__year-option:hover,
:global .react-datepicker__month-option:hover {
  background-color: #ccc;
}

:global .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
:global .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}

:global .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
:global .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}

:global .react-datepicker__year-option--selected,
:global .react-datepicker__month-option--selected {
  position: absolute;
  left: 15px;
}

:global .react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: inline-block;
  height: 0;
  outline: 0;
  padding: 0;
  vertical-align: middle;
}

:global .react-datepicker__close-icon::after {
  background-color: var(--color-yellow);
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "\00d7";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 7px;
  text-align: center;
  top: 50%;
}

:global .react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid var(--color-grey);
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

:global .react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}

:global .react-datepicker__portal .react-datepicker__day-name,
:global .react-datepicker__portal .react-datepicker__day, :global .react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}

@media (max-width: 400px), (max-height: 550px) {
  :global .react-datepicker__portal .react-datepicker__day-name,
  :global .react-datepicker__portal .react-datepicker__day, :global .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}

:global .react-datepicker__portal .react-datepicker__current-month, :global .react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

:global .react-datepicker__portal .react-datepicker__navigation {
  border: 0.81rem solid transparent;
}

:global .react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #ccc;
}

:global .react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: #b3b3b3;
}

:global .react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #ccc;
}

:global .react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: #b3b3b3;
}

:global .react-datepicker__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}

:global .react-datepicker__aria-live {
  position: absolute;
  clip-path: circle(0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
  white-space: nowrap;
}

:global .react-datepicker__navigation-icon {
  font-size: 0;
}

:global .react-datepicker__month-container > .react-datepicker__header {
  border-bottom: 0;
}

:global .react-datepicker__day-names {
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-grey);
  text-align: center;
}

:global .react-datepicker__navigation {
  box-sizing: content-box;
}

:global .react-datepicker__current-month {
  letter-spacing: normal;
}
